import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'haFeedbacksearchFilter'
})
export class HaFeedbacksearchFilterPipe implements PipeTransform {

  transform(patientData:any[], selectedRating:string): any[] {
    if(!patientData || !selectedRating || selectedRating=="-"){
      return patientData;
    }
    patientData.forEach(element => {
      if(element.Rate==null){
        element.Rate="0";
      }
    });
    return patientData.filter(ad=>
      
      
        ad.rate.toLowerCase().indexOf(selectedRating.toLowerCase().trim()) !== -1 
     );
  }

}
